import useApiMutation from 'shared/hooks/use-api-mutation';
import {ProductProps} from '../types';
import productsKeys from '../util/products-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useCreateAdditionalGroupConfig = (productId: string) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: ProductProps) =>
    setData(productsKeys.details(productId), data);

  return useApiMutation<ProductProps>({
    url: `/products/${productId}/additional-groups-config`,
    method: 'POST',
    errorTitle: 'Erro ao cadastrar grupo de adicionais do produto',
    successTitle: 'Cadastrar grupo de adicionais',
    successMessage: 'Grupo de adicionais cadastrado com sucesso',
    redirectUrl: (data) => `/menu/products/${data.id}/additional-group-configs`,
    onSuccess,
  });
};

export default useCreateAdditionalGroupConfig;
